import {UserManager} from "../managers";

const Post = {
    setContext: function (data, user){
        data.edges.forEach(edge => {
            let node = edge.node;
            node.isPinned = UserManager.getPinnedPostIds(user.info).includes(node.id);
            node.comments_count = node.commentSet.edges.length;
            node.documents_count = node.documentsUrls.length;
        });
        return data;
    }
};

export default Post;
